import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const FeedbackButtons = ({ onFeedback, show }) => {
  const [selectedFeedback, setSelectedFeedback] = useState(null);

  if (!show) return null;

  const feedbackOptions = [
    { id: 'too_cold', emoji: '🥶', label: 'Too Cold' },
    { id: 'just_right', emoji: '👍', label: 'Perfect' },
    { id: 'too_warm', emoji: '🔥', label: 'Too Warm' }
  ];

  const handleFeedback = (feedback) => {
    setSelectedFeedback(feedback);
    onFeedback(feedback);
  };

  return (
    <Card className="bg-white/60 dark:bg-gray-800/60 backdrop-blur-sm border-white/20">
      <CardContent className="p-4">
        <div className="text-center mb-3">
          <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
            How did this recommendation feel?
          </p>
        </div>
        <div className="flex justify-center gap-2">
          {feedbackOptions.map((option) => (
            <Button
              key={option.id}
              variant={selectedFeedback === option.id ? "default" : "outline"}
              size="sm"
              onClick={() => handleFeedback(option.id)}
              className="flex flex-col items-center gap-1 py-3 px-4"
              disabled={selectedFeedback !== null}
            >
              <span className="text-lg">{option.emoji}</span>
              <span className="text-xs">{option.label}</span>
            </Button>
          ))}
        </div>
        {selectedFeedback && (
          <p className="text-xs text-center text-muted-foreground mt-2">
            Thanks for your feedback! We'll use this to improve recommendations.
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default FeedbackButtons;